import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
import instameshGraphsVue from "@/components/SmartLink/dialog/instameshGraphs.vue";
import PrimaryGraphs from "./primaryGraphs.vue";
import statusLog from "./status-log.vue";
import pmpAp from "./pmp-ap.vue";
import PmpSm from "./pmp-sm.vue";
import RAOS from "@/components/RAOS/Components/Dialogs/RAOS.vue";

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
import { STRING_GENERAL, TYPES } from "@/constants/labels";

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'dialogComponent',
  props: {
  marca: { type: String },
  status: { type: String },
  ip: { type: String, required: true },
  typeSel: { type: String, required: true },
  name: { type: String, required: true },
},
  setup(__props) {

const { xs } = useDisplay();

/********************************
 ********** COMPONENTS **********
 *******************************/
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
const store = useStore();

const projectName = computed(() => store.state.projectName);



return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "card_dialog",
    color: "background"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "ma-0",
        justify: "space-between",
        style: {"align-items":"self-end !important"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "10" }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(_unref(xs) ? 'textDashboard' : 'subtitleDashboard')
              }, _toDisplayString(_unref(t)("title.graphTitle")) + " " + _toDisplayString(__props.name), 3)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "plain",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dialog', false)))
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "mt-7" }),
      _createVNode(_component_v_sheet, { color: "transparent" }, {
        default: _withCtx(() => [
          _createVNode(PrimaryGraphs, {
            ip: __props.ip,
            typesel: __props.typeSel,
            name: __props.name,
            status: __props.status
          }, null, 8, ["ip", "typesel", "name", "status"]),
          _createVNode(pmpAp, {
            ip: __props.ip,
            title: 'typeValue'
          }, null, 8, ["ip"]),
          _createVNode(statusLog, {
            ip: __props.ip,
            typesel: __props.typeSel,
            name: __props.name
          }, null, 8, ["ip", "typesel", "name"]),
          (projectName.value === 'SmartLinkRAOS')
            ? (_openBlock(), _createBlock(RAOS, {
                key: 0,
                ip: __props.ip,
                title: 'typeValue'
              }, null, 8, ["ip"]))
            : _createCommentVNode("", true),
          (__props.typeSel === _unref(STRING_GENERAL).quality_lap || __props.typeSel === _unref(TYPES).pmpsm)
            ? (_openBlock(), _createBlock(PmpSm, {
                key: 1,
                ip: __props.ip,
                title: 'typeValue'
              }, null, 8, ["ip"]))
            : _createCommentVNode("", true),
          (__props.typeSel !== _unref(TYPES).pmpap && __props.typeSel !== _unref(TYPES).pmpsm)
            ? (_openBlock(), _createBlock(instameshGraphsVue, {
                key: 2,
                ip: __props.ip,
                typeitem: __props.typeSel
              }, null, 8, ["ip", "typeitem"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})